<!--基础组件 疫情-->
<template>
    <div class="InfoWrapper">
        <div :class="{'numberCls':true,'blueColor':color=='blue','green':color=='green','yellow':color=='yellow','black':color=='black'}">
            <span >{{today ==null||today<0?"--":today}}</span>
        </div>
        <div class="nameText">{{name}}</div>
        <div class="textCls">
            <span>较上日  </span>
            <span :class="{'increase':true,'blueColor':color=='blue','green':color=='green','yellow':color=='yellow','black':color=='black'}">{{increase ==null||increase<0?"--":`+${increase}`}}</span>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Info",
        components: {},
        props: {
            name: {
                type: String,
                default: ""
            },
            today: {
                type: Number,
                default: 0
            },
            increase: {
                type: Number,
                default: 0
            },
            color:{
                type:String,
                default:'default'
            }
        },
        data() {
            return {};

        },
        methods: {}
    };
</script>
<style lang="less">
    @import "../../assets/less/common";
    .InfoWrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        padding: .2rem 0;
        .numberCls{
            font-size: .45rem;
            color: #FE3E3E;
            font-weight: 700;
            padding: .1rem 0;
        }

        .textCls {
            color: #9298A9;
            font-size: .36rem;
            padding: .1rem 0;
        }
        .increase{
            color: #FE3E3E;

        }
        .nameText{
            color: #000;
            font-size: .35rem;
            padding: .1rem 0;
        }

        .blueColor{
            color: @primary-color;
        }
        .green{
            color: #49B57F;
        }
        .yellow{
            color: #FEA93E;
        }
        .black{
            color: #171E32;
        }

    }

</style>
